import { clickTrack } from '.';

type DialTrackInfo = {
  dial_name: string;
  device_model: string;
  device_size: string;
  version: string;
  export_time: number;
};
/**
 * @description 创建表盘打点
 */
export const createDialTrack = (
  params: Omit<DialTrackInfo, 'version' | 'export_time'>
) => {
  clickTrack('create_dial', params);
};

/**
 * @description 导出表盘打点
 */
export const exportDialTrack = (params: DialTrackInfo) => {
  clickTrack('export_dial', params);
};
